<template>
  <cobrand :affiliates="true">
    <slot name="{ link }" >
      <div
        class="portal mh-100vh d-flex flex-column mt-0"
        :id="isQualifiedBorrower ? 'borrower-qualified' : 'borrower-dnq'"
        :style="styleCustomizations"
      >
        <LayoutBasePortal></LayoutBasePortal>
        <AppHeader :full="true" :link="link" :portal="true"></AppHeader>
        <div data-smooth-scroll="main" class="portal-content d-flex flex-grow-1">
          <PortalSideNav :zipNeeded="(!zipId && isDNQ)" />
          <div class="content flex-grow-1 col-lg-9 flex-lg-grow-0">
            <div class="content-wrap">

              <div v-if="pending">
                <div
                  class="loading-spinner justify-content-center text-center mt-5"
                >
                  <div class="spinner-border text-primary"></div>
                </div>
              </div>
              <ZipCode v-else-if="!zipId && isDNQ"></ZipCode>
              <NuxtPage v-else />
            </div>
            <div class="portal-body-footer-container w-100 mb-3">
              <MarketplaceFooter class="pt-0 mt-0 marketplace-footer" />
            </div>
          </div>
        </div>
      </div>
    </slot>
  </cobrand>
</template>

<script>
import MarketplaceFooter from '~/components/marketplace/MarketplaceFooter'
import AppHeader from '~/components/AppHeader'
import Cobrand from '~/components/Cobrand'
import LayoutBasePortal from './base-portal'
import PortalSideNav from '~/components/portal/PortalSideNav'
import ZipCode from '~/components/overview/ZipCode'
import get from 'lodash/get'
import { getStyleProps } from '~/libs/customizations'
import { usePortalStore } from '~/store/portal'
import { mapState } from 'pinia'
import { useRootStore } from '~/store/root'
import { useBorrowerStore } from '~/store/borrower'
import { useExperienceStore } from '~/store/experience'

export default {
  name: 'portal',
  components: {
    MarketplaceFooter,
    AppHeader,
    Cobrand,
    LayoutBasePortal,
    PortalSideNav,
    ZipCode,
  },
  async setup() {
    const nuxtApp = useNuxtApp()
    const borrowerStore = useBorrowerStore(nuxtApp.$pinia)

    const { pending } = useLazyAsyncData(() => Promise.all([
      borrowerStore.getBorrowerValues({ forceReload: true }),
      borrowerStore.getBorrowerExperiments({ forceReload: true }),
      borrowerStore.getLenderUser()
    ]))
    await useExperienceStore(nuxtApp.$pinia).forceGetExperience()

    return {
      pending
    }
  },
  props: ['link'],
  computed: {
    ...mapState(useBorrowerStore, {
      borrower: (store) => store,
      zipId: (store) => get(store, 'borrower.zipId'),
    }),
    ...mapState(usePortalStore, ['isQualifiedBorrower']),
    ...mapState(useExperienceStore, ['isDNQ']),
    styleCustomizations() {
      return getStyleProps()
    }
  },
}
</script>

<style lang="scss" scoped>
.portal {
  background-color: $neutral-100;
}
.mh-100vh {
  min-height: 100vh;
}

.portal-body-footer-container {
  position: absolute;
  bottom: 0;
  @include media-breakpoint-up(lg) {
    padding-left: 15px;
  }

  .marketplace-footer {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }
}

.content {
  position: relative;
  min-height: 90vh;
  @include media-breakpoint-down(lg) {
    margin-top: 70px;
  }
}

.content-wrap {
  margin-bottom: 150px;
  flex: 1 0 auto;
  @include media-breakpoint-down(lg) {
    margin-bottom: 250px;
  }
  @include media-breakpoint-down(md) {
    margin-bottom: 325px;
  }
}
</style>
